export const provider =
  process.env.REACT_APP_PROVIDER || "http://localhost:3000";
